import { useSubscribers } from "../../../../store/subscription/useSubscribers";

import { SubscriberController } from "../../../../services/controllers/subscription";

import { Alert } from "../../../../components/ui/Alert";
import { formatMoney } from "../../../../services/functions";

export function AlertRefundSubscription() {
  const details = useSubscribers(st => st.data.details)

  const CSubscriber = SubscriberController();

  if (!details) return null

  return (
    <Alert.Root name={CSubscriber.cycleRefundAlertName}>
      <Alert.Content>
        <Alert.Title>Confirmar estorno</Alert.Title>
        <ul className="space-y-3 mb-10">
          <li>Você está estornando o valor de <strong className="highlight">R$ {formatMoney(details?.plan?.price || 0)}</strong> para o cliente <strong className="highlight">{details?.customer?.name?.firstname}</strong>, no cartão final <strong className="highlight">{details?.cart?.lastDigits}</strong>.</li>
          <li>O estorno é solicitado imediatamente, porém o prazo para o valor aparecer na fatura pode variar conforme o banco/cartão.</li>
          <li>Para confirmar o prazo exato, o cliente deve entrar em contato com o banco emissor do cartão.</li>
          <li>Após confirmado e realizado com sucesso,<strong className="highlight"> o estorno não poderá ser cancelado ou revertido.</strong></li>
        </ul>
        <Alert.Actions>
          <Alert.Cancel>Cancelar</Alert.Cancel>
          <Alert.Confirm
            onClick={() => CSubscriber.refundTransactions(false, true)}
          >
            Confirmar estorno
          </Alert.Confirm>
        </Alert.Actions>
      </Alert.Content>
    </Alert.Root>
  )
}
